// frontend/utils/clipboard.ts

/**
 * 텍스트를 클립보드에 복사합니다.
 *
 * - HTTPS 환경: Clipboard API 사용 (브라우저 권장 방식)
 * - HTTP 환경: 구형 execCommand 폴백 (deprecated이지만 HTTP에서의 유일한 대안)
 *
 * @returns 성공하면 true, 실패하면 false
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      // HTTP 환경 폴백: textarea를 DOM 외부에 숨겨서 복사
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.cssText = "position:fixed;left:-9999px;top:-9999px";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    return true;
  } catch {
    return false;
  }
}
